// South Mountain Creamery's catalog, read live.
//
// The store (store.southmountaincreamery.com) searches through Algolia with
// a public search-only key shipped in its own page, and the index carries
// every product's name, size, price and category. So a lesson can show
// today's price for its cuts without anyone maintaining a list — and link
// straight to the item. It carries NO stock flag: "in the catalog" is not
// "available this week"; that only shows signed in against a delivery date.
//
// Cached for a day in localStorage. The prices move rarely and the request
// is not free for them.
const APP_ID = 'JMMSNKRPZU';
const SEARCH_KEY = '2210760d93f8d38758c41cb563586f27';
const INDEX = 'prod_SMCLive_Middletown';
const STORE = 'https://store.southmountaincreamery.com';
const CACHE_KEY = 'enjoyCookingCreameryCatalog';
const CACHE_MS = 24 * 60 * 60 * 1000;

export const itemUrl = (id, name = '') => {
  const slug = String(name).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  return `${STORE}/p/shop/item/${id}/${slug}`;
};

function readCache () {
  try {
    const raw = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
    if (raw && Date.now() - raw.at < CACHE_MS && raw.items) return raw.items;
  } catch { /* nothing cached */ }
  return null;
}

function writeCache (items) {
  try { localStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), items })); } catch { /* full or blocked */ }
}

/** id → { id, name, price, uom, vendor, category } for the whole catalog. */
export async function loadCatalog ({ fetchImpl = fetch } = {}) {
  const cached = readCache();
  if (cached) return cached;
  const response = await fetchImpl(`https://${APP_ID}-dsn.algolia.net/1/indexes/${INDEX}/query`, {
    method: 'POST',
    headers: {
      'X-Algolia-Application-Id': APP_ID,
      'X-Algolia-API-Key': SEARCH_KEY,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ query: '', hitsPerPage: 1000, attributesToRetrieve: ['ID', 'Name', 'Price', 'Measurement', 'Vendor', 'Categories'] })
  });
  if (!response.ok) throw new Error(`The creamery catalog responded ${response.status}`);
  const data = await response.json();
  const items = {};
  for (const hit of data.hits || []) {
    const category = hit.Categories?.[0];
    items[hit.ID] = {
      id: hit.ID,
      name: hit.Name,
      price: hit.Price,
      uom: hit.Measurement || '',
      vendor: hit.Vendor?.[0]?.name || '',
      category: category ? `${category.parent?.name} / ${category.child?.name}` : ''
    };
  }
  writeCache(items);
  return items;
}

/** "$8.99 / 1 lb" — or nothing, when the catalog has not loaded. */
export const priceLine = (item) => {
  if (!item) return '';
  const price = typeof item.price === 'number' ? `$${item.price.toFixed(2)}` : '';
  return [price, item.uom].filter(Boolean).join(' / ');
};
